export default __webpack_public_path__ + "static/media/jacket.737c89f9.png";